export const rmaRequest = 'rma-request';
export const rmaEnums = 'rma-enums';
